export default __webpack_public_path__ + "static/media/planimages_84b.05cc9580.png";